'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var get = require('./codegen-functions/get.js');
var inBounds = require('./codegen-functions/in-bounds.js');
var isObject = require('./codegen-functions/is-object.js');
var scope = require('./scope.js');



exports.get = get['default'];
exports.inBounds = inBounds['default'];
exports.isObject = isObject['default'];
exports.Scope = scope['default'];
